import { api, parseApiError } from './api';

export interface UserProfile {
  id: string;
  phoneNumber: string;
  email: string | null;
  name: string | null;
  language: string | null;
  timezone: string | null;
  createdAt: string;
}

export interface UserSubscription {
  plan: string;
  status: string;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
}

export interface ProfileResponse {
  user: UserProfile;
  subscription: UserSubscription | null;
}

export interface UpdateProfileData {
  email?: string;
  name?: string;
  language?: 'pt-BR' | 'en-GB';
}

export const profileService = {
  /**
   * Get current user profile with subscription info
   */
  async getProfile(): Promise<ProfileResponse> {
    try {
      const response = await api.get<ProfileResponse>('/api/me');
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Update user profile
   */
  async updateProfile(data: UpdateProfileData): Promise<{ user: UserProfile }> {
    try {
      const response = await api.put<{ user: UserProfile }>('/api/me', data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default profileService;
